import React, { forwardRef } from "react";
import Checkbox from "@mui/material/Checkbox";
import TableSortIcon from "../Table/TableSortIcon";
import { CheckBoxOutlineBlank } from "@mui/icons-material";

export const IndeterminateCheckbox = forwardRef(
  (
    {
      indeterminate,
      classes,
      onCheckRow,
      checked,
      iconClasses,
      onChange,
      ...rest
    },
    ref
  ) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    React.useEffect(() => {
      if (onCheckRow) {
        onCheckRow(checked);
      }
    }, [checked]);

    return (
      <>
        <Checkbox
          ref={resolvedRef}
          color="default"
          classes={classes}
          inputProps={{
            "data-qa": "react-table-checkbox"
          }}
          checked={checked}
          icon={<CheckBoxOutlineBlank classes={iconClasses} />}
          onChange={event => {
            onChange(event);
          }}
          sx={{ p: 0 }}
          {...rest}
        />
      </>
    );
  }
);

export const SortCell = ({ setSortBy, column }) => {
  return (
    <>
      <TableSortIcon
        sortDirection={
          column.isSorted ? (column.isSortedDesc ? "desc" : "asc") : ""
        }
        onClick={() => {
          setSortBy([{ id: column.id, desc: !column.isSortedDesc }]);
        }}
      />
    </>
  );
};
